<template>
    <i class="icon" :style="styleObject">
        <component :is="classObject"></component>
    </i>
</template>

<script>
import minusFaq from 'Svgs/collapse_faq.svg?inline';
import plusFaq from 'Svgs/expand_faq.svg?inline';

export default {
    name: 'Icon',
    components: {
        minusFaq,
        plusFaq,
    },
    props: ['type', 'color', 'size', 'background'],
    computed: {
        styleObject: function() {
            return {
                color: this.color || '#ffa306',
                'font-size': (this.size || 1) + 'em',
            };
        },
        classObject: function() {
            return this.type + 'Faq';
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
i {
    padding: 0;
}
</style>
